module.exports = __webpack_public_path__ + "img/L11.fafdd464.jpg";